import { SHOW_MESSAGE_BOX, CLEAR_MESSAGE_BOX } from '../constants/ActionTypes';

const messageBox = (state = null, action) => {
  switch (action.type) {
    case SHOW_MESSAGE_BOX:
      const { title, message } = action;
      return { title, message };
    case CLEAR_MESSAGE_BOX:
      return null;
    default:
      return state;
  }
}

export default messageBox;



// WEBPACK FOOTER //
// ./src/reducers/messageBox.js